import { AccountDetailsControllersDistributor } from '../VerticalGroupedPanels/Distributors/AccountDetailsControllersDistributor';
import { CustomEvent } from '@shared/utils/CustomEvents';
const PANEL_CLOSE_DELAY_MS = 500;
class _AccountWidgetAccountDetailsPanelController {
    constructor() {
        this.DataSource = null;
        this.AccountDetailsPanel = null;
        this.ShowAccountDetailsPanel = new CustomEvent();
        this.HideAccountDetailsPanel = new CustomEvent();
        this.hideTimeoutId = null;
        this.onAccountLinkOut = new CustomEvent();
        this.onRePopulatedPanel = new CustomEvent();
        this.onAssetSet = new CustomEvent();
        this.onPanelOpen = () => { };
        this.onPanelClose = () => { };
        this.isMouseOnPanelHandler = null;
        this.getDataProviderHandler = null;
        this.getDataSourceHandler = null;
    }
    HasPanel() {
        return !isNullOrUndefined(this.AccountDetailsPanel);
    }
    doShowAccountDetailsPanel(coordinates) {
        this.clearTimer();
        this.ShowAccountDetailsPanel.Raise(coordinates);
    }
    doHideAccountDetailsPanel() {
        if (!isNullOrUndefined(this.hideTimeoutId))
            return;
        this.hideTimeoutId = window.setTimeout(() => {
            this.hideTimeoutId = null;
            if (!this.isMouseOnPanel()) {
                this.HideAccountDetailsPanel.Raise();
                this.clearTimer();
            }
        }, PANEL_CLOSE_DELAY_MS);
    }
    getDataProvider() {
        if (this.getDataProviderHandler !== null) {
            return this.getDataProviderHandler();
        }
        return null;
    }
    getDataSource(type) {
        if (isNullOrUndefined(this.DataSource)) {
            return null;
        }
        return this.DataSource.getGroupController(type);
    }
    setDataSourceAccount(value) {
        if (isNullOrUndefined(this.DataSource)) {
            this.DataSource = new AccountDetailsControllersDistributor(value);
        }
        else {
            this.DataSource.Account = value;
        }
    }
    setDataSourceAsset(value) {
        if (!isNullOrUndefined(value) && !isNullOrUndefined(this.DataSource)) {
            this.DataSource.AssetBalance = value;
        }
    }
    accountLinkOut(newSubscriber, account, sameAccs) {
        this.onAccountLinkOut.Raise(newSubscriber, account, sameAccs);
    }
    raiseonRePopulatedPanel() {
        this.onRePopulatedPanel.Raise();
    }
    raiseonAssetSet(id) {
        this.onAssetSet.Raise(id);
    }
    isMouseOnPanel() {
        if (this.isMouseOnPanelHandler !== null) {
            return this.isMouseOnPanelHandler();
        }
        return false;
    }
    clearTimer() {
        if (this.hideTimeoutId !== null) {
            clearTimeout(this.hideTimeoutId);
            this.hideTimeoutId = null;
        }
    }
}
export const AccountWidgetAccountDetailsPanelController = new _AccountWidgetAccountDetailsPanelController();
